var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"wrapper-formulario"},[_c('v-form',{ref:"form",staticClass:"form"},[_vm._t("form")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }